module.exports = __webpack_public_path__ + "img/api-test.4ca9f71f.svg";